// AppScreenshots.jsx
// Mock UI screens shown in the About / Home pages
// Replace the SVG panels with real screenshots when available

const SCREENS = [
  {
    label: "Dashboard",
    accent: "#0A3D2E",
    content: (
      <g>
        {/* Header */}
        <rect x="0" y="0" width="220" height="36" fill="#0A3D2E"/>
        <text x="12" y="23" fontFamily="sans-serif" fontSize="11" fontWeight="700" fill="#C5F07A">Today's Overview</text>
        <circle cx="200" cy="18" r="6" fill="#A8E063" opacity="0.8"/>

        {/* KPI row */}
        {[["₹18,420","Revenue"],["47","Orders"],["12","Tables"],["3","KOTs"]].map(([v,l],i)=>(
          <g key={i} transform={`translate(${6+i*53},44)`}>
            <rect width="49" height="46" rx="8" fill="#EBF5EF"/>
            <text x="24.5" y="20" fontFamily="sans-serif" fontSize="9" fontWeight="800" fill="#0A3D2E" textAnchor="middle">{v}</text>
            <text x="24.5" y="33" fontFamily="sans-serif" fontSize="7" fill="#5A7A6A" textAnchor="middle">{l}</text>
          </g>
        ))}

        {/* Orders list */}
        <text x="8" y="106" fontFamily="sans-serif" fontSize="7" fontWeight="700" fill="#5A7A6A" textTransform="uppercase">RECENT ORDERS</text>
        {[
          ["Table 4 — Butter Chicken","₹480","Served","#16A34A"],
          ["Table 7 — Thali Set x2","₹760","Cooking","#B45309"],
          ["Takeaway — Biryani","₹320","Ready","#1D4ED8"],
          ["Table 2 — Masala Dosa","₹180","Served","#16A34A"],
        ].map(([name,amt,status,col],i)=>(
          <g key={i} transform={`translate(0,${114+i*26})`}>
            <rect x="6" y="0" width="208" height="22" rx="6" fill="#F5FAF7"/>
            <rect x="6" y="0" width="3" height="22" rx="1" fill="#117A58"/>
            <text x="16" y="14" fontFamily="sans-serif" fontSize="8" fontWeight="600" fill="#0D1F17">{name}</text>
            <text x="170" y="14" fontFamily="sans-serif" fontSize="8" fontWeight="700" fill="#1E3D2F">{amt}</text>
            <rect x="144" y="4" width="44" height="14" rx="4" fill={col} opacity="0.12"/>
            <text x="166" y="14" fontFamily="sans-serif" fontSize="7" fontWeight="600" fill={col} textAnchor="middle">{status}</text>
          </g>
        ))}
      </g>
    ),
  },
  {
    label: "Billing",
    accent: "#117A58",
    content: (
      <g>
        <rect x="0" y="0" width="220" height="36" fill="#117A58"/>
        <text x="12" y="23" fontFamily="sans-serif" fontSize="11" fontWeight="700" fill="white">New Bill — Table 5</text>

        {/* Items */}
        <text x="8" y="54" fontFamily="sans-serif" fontSize="7" fontWeight="700" fill="#5A7A6A">ORDER ITEMS</text>
        {[
          ["Butter Chicken","1","₹320"],
          ["Garlic Naan x2","2","₹80"],
          ["Mango Lassi","1","₹90"],
          ["Masala Papad","1","₹40"],
        ].map(([item,qty,price],i)=>(
          <g key={i} transform={`translate(0,${60+i*24})`}>
            <rect x="6" y="0" width="208" height="20" rx="5" fill={i%2===0?"#F5FAF7":"white"}/>
            <text x="14" y="13" fontFamily="sans-serif" fontSize="8" fontWeight="500" fill="#0D1F17">{item}</text>
            <text x="170" y="13" fontFamily="sans-serif" fontSize="8" fill="#5A7A6A" textAnchor="middle">×{qty}</text>
            <text x="210" y="13" fontFamily="sans-serif" fontSize="8" fontWeight="700" fill="#0A3D2E" textAnchor="end">{price}</text>
          </g>
        ))}

        {/* GST & Total */}
        <line x1="8" y1="162" x2="212" y2="162" stroke="#C8DDD4" strokeWidth="1"/>
        <text x="14" y="176" fontFamily="sans-serif" fontSize="8" fill="#5A7A6A">Subtotal</text>
        <text x="210" y="176" fontFamily="sans-serif" fontSize="8" fill="#5A7A6A" textAnchor="end">₹530</text>
        <text x="14" y="190" fontFamily="sans-serif" fontSize="8" fill="#5A7A6A">GST (5% CGST+SGST)</text>
        <text x="210" y="190" fontFamily="sans-serif" fontSize="8" fill="#5A7A6A" textAnchor="end">₹26.50</text>
        <rect x="6" y="196" width="208" height="24" rx="6" fill="#0A3D2E"/>
        <text x="110" y="212" fontFamily="sans-serif" fontSize="10" fontWeight="800" fill="#C5F07A" textAnchor="middle">Total: ₹556.50</text>

        {/* Pay buttons */}
        {[["Cash","#117A58"],["UPI","#1D4ED8"],["Card","#7C3AED"]].map(([m,c],i)=>(
          <g key={i} transform={`translate(${8+i*70},224)`}>
            <rect width="64" height="22" rx="6" fill={c} opacity="0.15"/>
            <text x="32" y="15" fontFamily="sans-serif" fontSize="8" fontWeight="700" fill={c} textAnchor="middle">{m}</text>
          </g>
        ))}
      </g>
    ),
  },
  {
    label: "Reports",
    accent: "#0D5C42",
    content: (
      <g>
        <rect x="0" y="0" width="220" height="36" fill="#0D5C42"/>
        <text x="12" y="23" fontFamily="sans-serif" fontSize="11" fontWeight="700" fill="#C5F07A">Sales Report</text>
        <rect x="150" y="10" width="62" height="16" rx="4" fill="rgba(168,224,99,.2)"/>
        <text x="181" y="21" fontFamily="sans-serif" fontSize="7" fill="#A8E063" textAnchor="middle">This Month</text>

        {/* Bar chart */}
        <text x="8" y="52" fontFamily="sans-serif" fontSize="7" fontWeight="700" fill="#5A7A6A">DAILY SALES (₹)</text>
        {[14,18,12,22,16,20,25,19,28,24,30,26,22,28,32].map((h,i)=>(
          <g key={i} transform={`translate(${8+i*13.5},54)`}>
            <rect x="2" y={50-h} width="9" height={h} rx="2" fill={i===14?"#A8E063":"#117A58"} opacity={0.7+i*0.02}/>
          </g>
        ))}

        {/* Summary stats */}
        <line x1="8" y1="116" x2="212" y2="116" stroke="#C8DDD4" strokeWidth="1"/>
        {[["Total Revenue","₹4,82,300"],["Orders","1,247"],["Avg. Bill","₹387"],["Top Item","Butter Chicken"]].map(([k,v],i)=>(
          <g key={i} transform={`translate(${6+(i%2)*106},${124+Math.floor(i/2)*34})`}>
            <rect width="100" height="28" rx="7" fill="#F5FAF7"/>
            <text x="10" y="12" fontFamily="sans-serif" fontSize="7" fill="#5A7A6A">{k}</text>
            <text x="10" y="23" fontFamily="sans-serif" fontSize="9" fontWeight="700" fill="#0A3D2E">{v}</text>
          </g>
        ))}

        <rect x="6" y="196" width="208" height="18" rx="5" fill="rgba(168,224,99,0.15)"/>
        <text x="110" y="208" fontFamily="sans-serif" fontSize="8" fontWeight="600" fill="#0A3D2E" textAnchor="middle">📤 Export to Excel</text>
      </g>
    ),
  },
];

export default function AppScreenshots() {
  return (
    <section className="screenshots-section">
      <div style={{ textAlign: "center", maxWidth: 520, margin: "0 auto 52px" }}>
        <div className="eyebrow">App Preview</div>
        <h2 className="sec-title">See Ooon <em>in action</em></h2>
        <p className="sec-sub" style={{ margin: "0 auto" }}>
          A preview of the real app interface — clean, fast, and built for busy restaurants.
          <br /><span style={{ fontSize: "0.82rem", color: "var(--muted)", marginTop: 6, display: "block" }}>
            Screenshots are illustrative. Replace with actual app images when available.
          </span>
        </p>
      </div>

      <div className="screenshots-row">
        {SCREENS.map((screen, i) => (
          <div className="screenshot-wrap" key={i}>
            <div className="screenshot-phone">
              {/* Phone chrome */}
              <div className="phone-notch" />
              <div className="phone-screen">
                <svg viewBox="0 0 220 250" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                  {screen.content}
                </svg>
              </div>
            </div>
            <div className="screenshot-label">{screen.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
